// ─────────────────────────────────────────────
//  claimStaffLink — client wrapper for the server-verified staff↔login claim.
//
//  Replaces the old direct `updateStaff(id, { uid })` self-claim. The rule
//  behind that write can only check "unlinked record, your own uid" — it
//  cannot re-check the name/short-code match the client used to choose the
//  record, so any signed-in user could claim any unlinked record. The callable
//  re-derives that match server-side (src/domain/staffLink.js) and writes with
//  the admin SDK.
//
//  Failure is non-fatal by design: a refused or unreachable claim leaves the
//  user unlinked (they see no channels) exactly as before — it must never
//  break rendering. The caller decides whether to surface anything.
// ─────────────────────────────────────────────
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "./config";

// Region must match the deployed function (firebase.json / functions default).
const REGION = "us-central1";

// Returns { linked: true, staffId } on success, or throws the callable's
// HttpsError (code strings: permission-denied / failed-precondition /
// not-found / unauthenticated).
export async function claimStaffLink(staffId) {
  const fns = getFunctions(app, REGION);
  const call = httpsCallable(fns, "claimStaffLink");
  const res = await call({ staffId });
  return res?.data;
}
